// extracted by mini-css-extract-plugin
export default {"cancellation":"CancellationPolicy_cancellation__hpJ0P","cancellation__content":"CancellationPolicy_cancellation__content__G1czx"};